import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge,
  CCard,
  CCardBody,
  CButton,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,CImg,
  CPagination,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CForm,CCardFooter,
  CFormGroup,
  CFormText,CDropdown,
  CLabel,CCardTitle,
  CInput,CInputGroup,CInputGroupText
} from 'compat/coreui'

import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';



const Deals = (props) => {
  const history = useNavigate();
  const [modal, setModal] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [discount, setDiscount] = useState("");
  const [discountType, setDiscountType] = useState("");
  const [dealsData, setDealsData] = useState([])
  const token = localStorage.getItem('token');



  const toggle = ()=>{
        setModal(!modal);
    }

  useEffect(async () => {
    getDeals()
  }, [])



    const getDeals = () =>{
        axios({
          url: `${process.env.REACT_APP_APP_API_URL}/api/deal`,
          method: 'GET',
          headers: {
            'Authorization': 'Bearer '+token
          }
        }).then(response => {
            if(response.data.status){
              setDealsData(response.data.deals);
            }
      }).catch(console.log)
  }

 
  const addDeals  = (e) => {
    e.preventDefault()
    const data = {
      "description": description,
      "title": title,
      "category": category,
      "type": type,
      "discount": discount,
      "discountType": discountType,
    }
    axios({
          url: `${process.env.REACT_APP_APP_API_URL}/api/deal`,
          method: 'POST',
          headers: {
            'Authorization': 'Bearer '+token
          },
          data
        }).then(response => {
            if(response.data.status){
              setModal(!modal);
              toast.success('Deal added successfully')
            }
      }).catch(console.log)
  }

  
  return (
    <React.Fragment>
      <CRow>
        <CCol xl={12}>
          <CCard>
            <CCardHeader className="deal-dashboard_header p-4">
              <CCol lg={3} className="pr-0">
                <span>
                  <CImg src="/images/money.png"  className="mr-4"/>0 credits available
                </span>
              </CCol>
              <CCol>
                <CButton color="success" className="text-white p-3 mt-2">PURCHASE MORE CREDITS</CButton>
              </CCol>
            </CCardHeader>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol><h2>Active Deals</h2></CCol>
      </CRow>
      <CRow>
        <CCol lg={3}>
          <CCard className="add_deal" onClick={toggle}>
          <CCardBody>
            <CImg src="/images/p-tag.png" />
            <p>Add Deal</p>
            <span>1 CREDIT</span>
          </CCardBody>
        </CCard>
        </CCol>
        <CCol lg={9} className="mt-5">
          {dealsData.length > 0 && dealsData.map((dealItem, i) =>
           {return(<CCol lg={4} key={i}>
                    <CCard className="deal-page-card">
                      <CCardHeader className="p-0 b-header">
                        <CImg src="/images/jack.png" width="100%"></CImg>
                      </CCardHeader>
                      <CCardBody className="text-center">
                        <CCardTitle>
                          <p>{dealItem.title}</p>
                        </CCardTitle>
                      </CCardBody>
                      <CCardFooter className="biz-deal deals-footer">
                        <span>Flower</span><span>Both</span><span>2096</span>
                      </CCardFooter>
                   </CCard>
                </CCol>)
            })}
        </CCol>
      </CRow>
      <CModal
              show={modal}
              onClose={toggle}
            >
              <CModalHeader closeButton className="text-white" style={{background: "#FF5F1F"}}>Add A Deal</CModalHeader>
              <CModalBody>
                <CCardTitle>
                    Add Details
                </CCardTitle>
                <form>
                  <CFormGroup className="d-flex">
                    <CCol xl={3} className="pr-0">
                        <CLabel htmlFor="nf-title">Pricing</CLabel>
                        <CDropdown className="btn-lg" style={{padding: '0px'}}>
                          <select className="custom-select my-1 mr-sm-2 product_status" name="discountType" onChange={(e) => setDiscountType(e.target.value)}>
                             <option value={`2`}>%</option>
                             <option value={`1`}>$</option>
                             <option value={`3`}>BOGO</option>
                          </select>
                        </CDropdown>
                    </CCol>
                    <CCol xl={2} className="pr-0">
                      <CLabel htmlFor="nf-title" className="pb-1">&nbsp;</CLabel>
                      <CInput type="text" placeholder="0" name="discount" onChange={(e) => setDiscount(e.target.value)}/>
                    </CCol>
                    <CCol xl={7} className="pr-0">
                      <CLabel htmlFor="nf-title" className="pb-1">Title</CLabel>
                      <CInput type="text" placeholder="eg. Grams of Wax" name="title" onChange={(e) => setTitle(e.target.value)}/>
                    </CCol>
                  </CFormGroup>

                   <CFormGroup className="d-flex">
                    <CCol className="pr-0">
                      <CLabel htmlFor="nf-title" className="pb-1">Description(optional)</CLabel>
                      <CInput type="textarea" placeholder="eg. Grams of Wax" name="description" onChange={(e) => setDescription(e.target.value)}/>
                    </CCol>
                  </CFormGroup>
                  <CFormGroup className="d-flex">
                    <CCol className="pr-0">
                      <CLabel htmlFor="nf-title" className="pb-1">Image</CLabel><br/>
                      <div className="fileUpload btn btn-primary">
                        <span>Select File</span>
                        <input type="file" className="upload" />
                      </div>
                    </CCol>
                    <CCol>
                      <CLabel htmlFor="nf-title">Type</CLabel>
                        <CDropdown className="btn-lg" style={{padding: '0px'}}>
                          <select className="custom-select my-1 mr-sm-2 product_status" name="type" onChange={(e) => setType(e.target.value)}>
                             <option value={`Medical`}>Medical</option>
                             <option value={`Recreational`}>Recreational</option>
                             <option value={`Both`}>Both</option>
                          </select>
                        </CDropdown>

                        <CLabel htmlFor="nf-title">Category</CLabel>
                        <CDropdown className="btn-lg" style={{padding: '0px'}}>
                          <select className="custom-select my-1 mr-sm-2 product_status" name="category" onChange={(e) => setCategory(e.target.value)}>
                             <option value="bud">Flower</option>
                             <option value="concentrates">Concentrates</option>
                             <option value="edibles">Edibles</option>
                             <option value="seeds">Seeds</option>
                             <option value="prerolls">Prerolls</option>
                             <option value="vaporizers">Vaporizers</option>
                             <option value="other">Other</option>
                          </select>
                        </CDropdown>
                        {/*<div className="apply_type">
                           <CLabel htmlFor="nf-title" className="apply_type">Check any that apply</CLabel>
                           <span><CInput type="checkbox" className="category-checkbox"/> Gram Deal</span>
                           <span><CInput type="checkbox" className="category-checkbox"/> 1/8th Deal</span>
                           <span><CInput type="checkbox" className="category-checkbox"/> Ounce Deal</span>
                           <span><CInput type="checkbox" className="category-checkbox"/> High CBD</span>
                         </div>*/}
                    </CCol>
                  </CFormGroup>
                  <CCol className="mt-5">
                      <CButton color="success" type="submit" onClick={addDeals}>POST DEAL</CButton>{' '}
                      <CButton
                        color="secondary"
                        className="pl-4 pr-4"
                        onClick={toggle}>
                          Cancel
                      </CButton>
                  </CCol>
                </form>
              </CModalBody>
            </CModal>
    </React.Fragment>
  )
}

export default Deals;
